export default __webpack_public_path__ + "7e79deb12728628a21da49f245b5c4a5.png";